export default {
  data() {
    return {
      goodsImg: "https://filesouthcdn.nxin.com/nxsc_149330388885405156278078075854.JPEG",
      goodsImgs: ["https://filesouthcdn.nxin.com/nxsc_149330388885405156278078075854.JPEG"],
      tabsActive: 0,
    };
  },
};
